/**
 * Merkt sich den zuletzt gewaehlten Investitionsort im localStorage, damit das
 * Schnell-Erfassen ihn vorbelegen kann (weniger Taps). Enthaelt keine sensiblen
 * Betraege – nur eine Bereichs-UUID.
 */

const SCHLUESSEL = 'finanzen.letzterOrt';

/** Liefert die zuletzt gewaehlte Ort-UUID (oder null). */
export const letzterOrt = () => {
  try {
    return window.localStorage.getItem(SCHLUESSEL) || null;
  } catch (ex) {
    return null;
  }
};

/** Merkt sich die zuletzt gewaehlte Ort-UUID fuer die naechste Buchung. */
export const merkeOrt = (uuid) => {
  try {
    if (uuid) window.localStorage.setItem(SCHLUESSEL, uuid);
  } catch (ex) {
    // localStorage nicht verfuegbar – ohne Vorbelegung weiterarbeiten.
  }
};
